<div class="sidebar" [class.collapsed]="isCollapsed" [attr.data-modo]="modo">
  <div class="sidebar-header">
    <span class="logo" title="Transparencia da Educacao">
      <img src="../../../../assets/images/logo-sai.png" class="img-fluid">
    </span>
    <span class="title" *ngIf="exibirRotulos">Administrativo</span>

    <button
      class="toggle-btn"
      *ngIf="podeAlternar"
      type="button"
      [title]="isCollapsed ? 'Abrir menu' : 'Recolher menu'"
      [attr.aria-label]="isCollapsed ? 'Abrir menu' : 'Recolher menu'"
      (click)="toggleSidebar()"
      [attr.aria-expanded]="!isCollapsed">
      <i-lucide name="menu" color="#fff"></i-lucide>
    </button>
  </div>

  <nav class="menu">
    <ng-container *ngFor="let item of menuItems">
      <a *ngIf="!item.children" class="menu-item" [routerLink]="item.route" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.exact || false }" [title]="item.label">
        <i-lucide [name]="item.icon" [title]="item.label"></i-lucide>
        <span *ngIf="exibirRotulos">{{ item.label }}</span>
      </a>

      <div *ngIf="item.children" class="menu-group" [class.active-group]="isMenuItemActive(item)">
        <button type="button" class="menu-item menu-group-title" (click)="toggleMenuItem(item)"
          [title]="item.label" [attr.aria-expanded]="item.expanded || false">
          <i-lucide [name]="item.icon" [title]="item.label"></i-lucide>
          <span *ngIf="exibirRotulos">{{ item.label }}</span>
          <i-lucide *ngIf="exibirRotulos" class="menu-chevron"
            [name]="item.expanded ? 'chevron-up' : 'chevron-down'"></i-lucide>
        </button>

        <div class="submenu" *ngIf="item.expanded">
          <ng-container *ngFor="let child of item.children">
            <a *ngIf="!child.children" class="submenu-item" [class.disabled]="child.disabled"
              [routerLink]="child.disabled ? null : child.route" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: child.exact || false }" [title]="child.label"
              [attr.aria-disabled]="child.disabled || null">
              <i-lucide *ngIf="!exibirRotulos || modo === 'mobile'" [name]="child.icon" size="18"></i-lucide>
              <span *ngIf="exibirRotulosSubmenu">{{ child.label }}</span>
            </a>

            <div *ngIf="child.children" class="submenu-group" [class.active-group]="isMenuItemActive(child)">
              <button type="button" class="submenu-item submenu-group-title" (click)="toggleMenuItem(child)"
                [title]="child.label" [attr.aria-expanded]="child.expanded || false">
                <i-lucide [name]="child.icon" size="18"></i-lucide>
                <span *ngIf="exibirRotulosSubmenu">{{ child.label }}</span>
                <i-lucide *ngIf="exibirRotulosSubmenu" class="submenu-chevron"
                  [name]="child.expanded ? 'chevron-up' : 'chevron-down'" size="15"></i-lucide>
              </button>

              <div class="submenu-nested" *ngIf="child.expanded">
                <ng-container *ngFor="let grandchild of child.children">
                  <a *ngIf="!grandchild.disabled" class="submenu-item submenu-nested-item"
                    [routerLink]="grandchild.route" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: grandchild.exact || false }" [title]="grandchild.label">
                    <i-lucide [name]="grandchild.icon" size="16"></i-lucide>
                    <span *ngIf="exibirRotulosSubmenu">{{ grandchild.label }}</span>
                  </a>

                  <button *ngIf="grandchild.disabled" type="button"
                    class="submenu-item submenu-nested-item disabled" disabled [title]="grandchild.label + ' — em breve'">
                    <i-lucide [name]="grandchild.icon" size="16"></i-lucide>
                    <span *ngIf="exibirRotulosSubmenu">{{ grandchild.label }}</span>
                    <span *ngIf="exibirRotulosSubmenu" class="submenu-coming-soon">Em breve</span>
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    @if (exibirMenuMaster) {
      <a *ngFor="let item of masterMenuItems" class="menu-item" [routerLink]="item.route" routerLinkActive="active"
        [title]="item.label">
        <i-lucide [name]="item.icon" [title]="item.label"></i-lucide>
        <span *ngIf="exibirRotulos">{{ item.label }}</span>
      </a>
    }
  </nav>
</div>
